/*
 * Resumen de opiniones junto a las estrellas de Judge.me en la PDP.
 *
 * El badge de Judge.me (app block) ya trae los datos en su propio DOM:
 *   .jdgm-prev-badge[data-average-rating][data-number-of-reviews]
 * Con ellos se pinta "4.85 de 5 · Basado en 369 opiniones" (texto traducido desde Liquid, en
 * data-text-one / data-text-other de [data-mm-reviews-summary]) y, al hacer clic en el badge o en
 * el texto, se abre la pestaña "Opiniones" y se lleva la vista hasta ella.
 * Si no existe la pestaña (#judgeme_product_reviews) no se toca nada y Judge.me hace lo suyo.
 */
(() => {
  if (window.mmReviewsSummaryInitialized) return;
  window.mmReviewsSummaryInitialized = true;

  const WRAP = '[data-mm-reviews-summary]';
  const TEXT_CLASS = 'mm-reviews-summary__text';

  const getDetails = () => document.getElementById('judgeme_product_reviews')?.closest('details') || null;

  const render = (wrap) => {
    const badge = wrap.querySelector('.jdgm-prev-badge');
    let button = wrap.querySelector(`.${TEXT_CLASS}`);
    const rating = parseFloat(badge?.dataset.averageRating);
    const count = parseInt(badge?.dataset.numberOfReviews, 10);

    if (!badge || !getDetails() || !(count > 0) || Number.isNaN(rating)) {
      button?.remove();
      return;
    }

    const template = count === 1 ? wrap.dataset.textOne : wrap.dataset.textOther;
    if (!template) return;
    const text = template
      .replace('%RATING%', String(rating))
      .replace('%COUNT%', count.toLocaleString(document.documentElement.lang || undefined));

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = TEXT_CLASS;
      if (wrap.dataset.label) button.setAttribute('aria-label', wrap.dataset.label);
      wrap.appendChild(button);
    }
    if (button.textContent !== text) button.textContent = text;
  };

  const openAndScroll = (details) => {
    details.open = true;
    const target = details.querySelector('summary') || details;
    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    const offset = (header ? header.offsetHeight : 0) + 16;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Dos fotogramas: que el <details> ya esté abierto y maquetado antes de medir.
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
        target.focus?.({ preventScroll: true });
      })
    );
  };

  const setup = (wrap) => {
    if (wrap.dataset.mmReviewsSummaryReady) return;
    wrap.dataset.mmReviewsSummaryReady = 'true';

    render(wrap);
    new MutationObserver(() => render(wrap)).observe(wrap, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-average-rating', 'data-number-of-reviews'],
    });

    const activate = (event) => {
      if (!event.target.closest(`.${TEXT_CLASS}, .jdgm-prev-badge`)) return;
      const details = getDetails();
      if (!details) return;
      // En captura y cortando la propagación: así el scroll propio de Judge.me no compite con el nuestro.
      event.preventDefault();
      event.stopPropagation();
      openAndScroll(details);
    };
    wrap.addEventListener('click', activate, true);
    wrap.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Enter' || event.key === ' ') activate(event);
      },
      true
    );
  };

  const init = () => document.querySelectorAll(WRAP).forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
